import { openEventQuickComposeView } from '../actions/publicActions';
import { pushNewView } from '../actions/timePanelStoreActions';
import { verifyValidSource } from '../utils/verifyValidSource';
import { lazyShowQuickCompose } from 'owa-calendar-compose-form-store/lib/quickCompose/quickComposeIndex';
import { openTimePanel, popView } from 'owa-time-panel-bootstrap';
import { getCurrentPanelView } from 'owa-time-panel-view-stack';
import { orchestrator } from 'satcheljs';

export const openEventQuickComposeViewOrchestrator = orchestrator(
    openEventQuickComposeView,
    actionMessage => {
        const { source, event } = actionMessage;

        // verify source for telemetry purposes
        if (!verifyValidSource(source)) {
            return;
        }

        // make sure panel is open
        openTimePanel(source);

        // handle any existing compose forms
        if (getCurrentPanelView() === 'ComposeForm') {
            //VSO 54580 : Do not popView away from dirty compose form
            popView();
        }

        // open directly to compose form
        pushNewView('ComposeForm');
        lazyShowQuickCompose.importAndExecute(
            null /* anchor */,
            'TimePanel' /* entrySource */,
            'TimePanel' /* viewType */,
            event
        );
    }
);
